import SiteRegistrationProps from "@mediaspace/features/registration/registration/SiteRegistrationProps";
import { SiteRegistration } from "@mediaspace/features/registration";
import { useEffect, useState } from "react";
import { Button, Modal, ModalActions, ModalContent, ModalTitle, Typography } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";

export interface SiteRegistrationDrawerContainerProps {
    /**
     * props for registration form
     */
    siteRegistrationProps: SiteRegistrationProps;

    shouldClose: boolean;

    onClose: () => void;

    onCancel: () => void;
}

/**
 * container for the drawer content, to hold site registration component and a confirmation modal
 */
export function SiteRegistrationDrawerContainer({
    siteRegistrationProps,
    shouldClose,
    onClose,
    onCancel,
}: SiteRegistrationDrawerContainerProps) {
    const [showModal, setShowModal] = useState(false);
    const baseClassName = "kms-ds-exit-site-registration-modal";

    useEffect(() => {
        if (shouldClose) {
            setShowModal(true);
        }
    }, [shouldClose, onClose]);

    return (
        <>
            <SiteRegistration {...siteRegistrationProps} fullWidth={false} />
            <Modal
                classes={{
                    root: `${baseClassName}-root`,
                    paper: `${baseClassName}-paper`,
                }}
                open={showModal}
            >
                <ModalTitle className={`${baseClassName}-title`}>{translate("Exit registration")}</ModalTitle>
                <ModalContent className={`${baseClassName}-content`}>
                    <Typography variant={"body1"}>
                        {translate("Are you sure you want to exit? All changes will be lost")}
                    </Typography>
                </ModalContent>
                <ModalActions className={`${baseClassName}-actions`}>
                    <Button
                        className={`${baseClassName}-cancel-button`}
                        variant={"borderless"}
                        color={"secondary"}
                        onClick={() => {
                            setShowModal(false);
                            onCancel();
                        }}
                    >
                        {translate("Cancel")}
                    </Button>
                    <Button
                        className={`${baseClassName}-exit-button`}
                        onClick={() => {
                            setShowModal(false);
                            onClose();
                        }}
                        color={"danger"}
                    >
                        {translate("Exit registration")}
                    </Button>
                </ModalActions>
            </Modal>
        </>
    );
}

export default SiteRegistrationDrawerContainer;
